// extracted by mini-css-extract-plugin
export default {"oMContent":"OurMission_oMContent__ztTSx","arrow":"OurMission_arrow__6oZ6q"};